import { render, staticRenderFns } from "./listPermissions.vue?vue&type=template&id=31c4e7b4&"
import script from "./listPermissions.vue?vue&type=script&lang=js&"
export * from "./listPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c4e7b4')) {
      api.createRecord('31c4e7b4', component.options)
    } else {
      api.reload('31c4e7b4', component.options)
    }
    module.hot.accept("./listPermissions.vue?vue&type=template&id=31c4e7b4&", function () {
      api.rerender('31c4e7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/listPermissions.vue"
export default component.exports